import { Box } from "@mui/material";
import EntityGridList from "./EntityGridList";
import ShowFilterPane from "./ShowFilterPane";
import TopToolbar from "./TopToolbar";

const EntertainmentEntityManager = ({
    scrollRef,
    entertainment_entity_data,
    entertainment_entity_filter,
    setEntertainmentEntity,
    searchText,
    setSearchText,
    handleCreateUpdateClick,
    onCreateClick,
    handleShowFilter,
    showFilter,
    setShowFilter,
    applyFilter,
    setApplyFilter,
    entityType,
    setEntityType,
    handleSearch,
    handleClearSearch,
    languageFilter,
    setLanguageFilter,
    countryFilter,
    setCountryFilter,
    industryFilter,
    setIndustryFilter,
    artistTypeFilter,
    setArtistTypeFilter,
    year,
    setYear,
    handleClearFilters,
}) => {
    return (
        <>
            <Box sx={{ flex: 1, height: "100%", padding: 3, marginTop: 2, paddingBottom: 10 }}>

                <TopToolbar
                    searchText={searchText}
                    setSearchText={setSearchText}
                    onCreateClick={onCreateClick}
                    onToggleFilter={handleShowFilter}
                    handleSearch={handleSearch}
                    handleClearSearch={handleClearSearch}
                />

                <EntityGridList
                    scrollRef={scrollRef}
                    entertainment_entity_data={entertainment_entity_data}
                    setEntertainmentEntity={setEntertainmentEntity}
                    handleCreateUpdateClick={handleCreateUpdateClick}
                />

            </Box>

            <ShowFilterPane
                entertainment_entity_data={entertainment_entity_data}
                entertainment_entity_filter={entertainment_entity_filter}
                showFilter={showFilter}
                setShowFilter={setShowFilter}
                applyFilter={applyFilter}
                setApplyFilter={setApplyFilter}
                entityType={entityType}
                setEntityType={setEntityType}
                languageFilter={languageFilter}
                setLanguageFilter={setLanguageFilter}
                countryFilter={countryFilter}
                setCountryFilter={setCountryFilter}
                industryFilter={industryFilter}
                setIndustryFilter={setIndustryFilter}
                artistTypeFilter={artistTypeFilter}
                setArtistTypeFilter={setArtistTypeFilter}
                year={year}
                setYear={setYear}
                handleClearFilters={handleClearFilters}
            />
        </>
    );
}

export default EntertainmentEntityManager;